module.exports = __webpack_public_path__ + "img/9.ce1ee85c.jpg";